import http from '@/utils/http';
import i18n from '@/main';

export default {
    consultar(tipo, documento, salvar = true, lockscreen = true, arquivo, codigoProtocolo) {
        return this.consultarInterno(tipo, documento, salvar, lockscreen, arquivo, codigoProtocolo, false);
    },

    consultarEmLote(tipo, documento, salvar, codigoProtocolo) {
        return this.consultarInterno(tipo, documento, salvar, false, null, codigoProtocolo, true);
    },

    buscarProdutividadeCar(codigoCar) {
        return http.get({
            url: `/diagnostico/produtividade/${codigoCar}`,
            lockScreen: false
        });
    },

    consultarInterno(tipo, documento, salvar, lockscreen, arquivo, codigoProtocolo, lote) {
        const documentoComMascara = /[.\-/]/.test(documento || '');
        const usarBody =
            tipo === 'CAR_ESTADUAL_MT' ||
            (tipo === 'CPF_CNPJ' && documentoComMascara);

        const documentoPath = usarBody ? 'documento' : documento;
        const documentoBody = usarBody ? documento : arquivo;

        let path = `/diagnostico/buscar-dados/socioambiental/${tipo}/${documentoPath}?salvar=${salvar}&lote=${lote}`;
        if (codigoProtocolo) {
            path = path.concat(`&codigoProtocolo=${codigoProtocolo}`);
        }

        return http.post({
            url: path,
            lockScreen: lockscreen,
            lockMessage: i18n.t('mensagens.sistema.realizandoDiagnosticoSocioambiental'),
            data: { arquivo: documentoBody }
        });
    },

    buscarPorId(idDiagnostico) {
        return http.get({
            url: `diagnostico-socioambiental/${idDiagnostico}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoDiagnosticoSocioambientalSalvo')
        });
    },

    analisarBuffer(geometria, idDiagnosticoSocioambiental, codigoProtocolo) {
        let path = `/diagnostico/${idDiagnosticoSocioambiental}/analisar-buffer`;
        if (codigoProtocolo) {
            path = path.concat(`?codigoProtocolo=${codigoProtocolo}`);
        }

        return http.post({
            url: path,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.realizandoDiagnosticoSocioambientalDasAreasProximas'),
            data: { geometrias: geometria }
        });
    },

    exportarPdf(params) {
        return http.post({
            url: '/diagnostico/exportar/pdf',
            data: { dados: params },
            lockScreen: false
        });
    },

    async verifyUrl(url) {
        try {
            const response = await http.get({
                url: url,
                lockScreen: true,
                lockMessage: i18n.t('mensagens.sistema.verificandoDisponibilidadeDoServico')
            });
            if (response.status >= 200 && response.status <= 299) {
                return true;
            }
            return false;
        } catch (err) {
            return false;
        }
    },

    consultaControleDiagnostico(body, { page, size, sort }) {
        return http.post({
            url: `/diagnostico/filtrar-relatorio?page=${
                page - 1
            }&size=${size}&sort=${sort}`,
            data: body,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosDeDiagnosticos')
        });
    },

    graficoControleDiagnostico(body) {
        return http.post({
            url: `/diagnostico/grafico`,
            data: body,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoGraficosDeDiagnosticos')
        });
    },

    realizarDiagnosticoCadastroTerritorio(idTerritorio, protocolo) {
        let path = `diagnostico-socioambiental/cadastro-territorio/${idTerritorio}`;
        if (protocolo) {
            path = path.concat(`?protocolo=${protocolo}`);
        }

        return http.get({
            url: path,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.realizandoDiagnosticoSocioambiental')
        });
    },

    exportarControleRequisicaoDiagnostico(body) {
        const fileLink = document.createElement('a');
        try {
            return http
                .post({
                    url: `/diagnostico/requisicao-xlsx`,
                    data: body,
                    responseType: 'blob',
                    lockScreen: true,
                    lockMessage: i18n.t('mensagens.sistema.preparandoDadosParaDownload')
                })
                .then(response => {
                    if (response.status === 200) {
                        const fileURL = window.URL.createObjectURL(
                            new Blob([response.data])
                        );
                        fileLink.href = fileURL;
                        const filenameRegex =
                            /filename=['"]?([^;\r\n"']*)['"]?;?/;
                        const contentDisposition =
                            response.headers['content-disposition'];

                        fileLink.setAttribute(
                            'download',
                            filenameRegex.exec(contentDisposition)[1]
                        );
                        document.body.appendChild(fileLink);

                        fileLink.click();
                        return Promise.resolve();
                    }
                });
        } catch (error) {
            return Promise.reject(error);
        } finally {
            fileLink.remove();
        }
    },

    buscarDiagnosticoCarDoTerritorio(territorio, protocolo) {
        return new Promise((resolve, reject) => {
            if (
                territorio &&
                territorio.dadosTerritorio &&
                territorio.dadosTerritorio.cars &&
                territorio.dadosTerritorio.cars.length
            ) {
                const promises = [];
                territorio.dadosTerritorio.cars.forEach(car => {
                    let path = `/diagnostico/${territorio.idDiagnosticoSocioambiental}/car/${car.codigo}`;
                    if (protocolo) {
                        path = path.concat(`?codigoProtocolo=${protocolo}`);
                    }
                    if (car.codigo) {
                        const request = http.get({ url: path });
                        promises.push(request);
                    }
                });
                Promise.all(promises)
                    .then(responses => {
                        const responseCars = [];
                        responses.forEach(({ data, status }) => {
                            if (status === 200 && data && data.imovel) {
                                responseCars.push(data);
                            }
                        });
                        resolve(responseCars);
                    })
                    .catch(error => {
                        reject(error);
                    });
            } else {
                resolve([]);
            }
        });
    }
};
